export default __webpack_public_path__ + "static/media/potluck.be0460ee.png";